import { render, staticRenderFns } from "./NewFieldValue.vue?vue&type=template&id=86b8404c&scoped=true&"
import script from "./NewFieldValue.vue?vue&type=script&lang=js&"
export * from "./NewFieldValue.vue?vue&type=script&lang=js&"
import style0 from "./NewFieldValue.vue?vue&type=style&index=0&id=86b8404c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86b8404c",
  null
  
)

export default component.exports